var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeguridad24Circle = function SvgSeguridad24Circle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.916 18.583A.416.416 0 0 0 23.5 19v2.083h-3.527l-2.964-4.445 4.19-2.419a.417.417 0 0 0 .153-.569l-2.917-5.052a.42.42 0 0 0-.415-.205.414.414 0 0 0-.154.053l-8.66 5a.417.417 0 0 0-.153.569l.626 1.083-1.805 1.041a.416.416 0 0 0-.152.57l1.25 2.164a.417.417 0 0 0 .57.152l1.803-1.041.625 1.083a.42.42 0 0 0 .36.208c.074 0 .146-.02.209-.056l3.747-2.163 3.117 4.675a.417.417 0 0 0 .346.185h3.75V24a.417.417 0 1 0 .834 0v-5a.416.416 0 0 0-.417-.417Zm-12.987-1.32-1.443.833-.834-1.444 1.443-.833.834 1.443Zm1.555 1.026-2.5-4.33 7.938-4.584 2.5 4.331-7.938 4.584Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.535,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#765346"
  })));
};
export default SvgSeguridad24Circle;